<div class="flex flex-col gap-6">

  <app-sub-product-form
    #subForm
    [productId]="productId()"
    [attributes]="attributes()"
    [categories]="categories()"
    [parentTitleEn]="parentTitleEn()"
    [parentTitleAr]="parentTitleAr()"
    [existingSubProducts]="subProductsList()"
    (onAdded)="onSubProductAdded($event)" />

  <!-- @if (subProductsList().length > 0) {
    <app-sub-products-table
      [subProductsList]="subProductsList()"
      [duplicateRowIndex]="subForm.duplicateRowIndex()"
      (onRemove)="removeFromTable($event)" />
  } -->

  <div class="mt-4 flex justify-end gap-4">
    <button type="button" (click)="onBack.emit()"
      class="rounded-xl border border-gray-300 px-8 py-2.5 font-bold text-gray-500 hover:bg-gray-50 cursor-pointer"
      i18n="@@product.button.back">Back</button>
      
    <button type="button" (click)="handleFinalSave()"
      [disabled]="subProductsList().length === 0"
      class="rounded-xl bgTabsColor px-12 py-2.5 font-bold text-white shadow-md disabled:opacity-50 cursor-pointer"
      i18n="@@subProduct.button.Save">Save</button>
  </div>

</div>

@if (showSubProductSuccess()) {
  <app-successful-notification 
    type="success" 
    i18n-title="@@subProduct.success.added"
    title="Sub-product has been added successfully." />
}